import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { first, takeUntil } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LgvClientService, LgvSnapshotHelper, NotificationService } from '../../core/core.module';
import { AdjustHomeValueDialogComponent } from '../adjust-home-value-dialog/adjust-home-value-dialog.component';
import { Subject } from 'rxjs';


@Component({
    selector: 'lus-avm-pop-up',
    templateUrl: './avm-popup.component.html',
    styleUrls: ['./avm-popup.component.scss']
})
export class AvmPopUpComponent implements OnInit {

    marketValueHistory: any;
    isManuallyAdjusted: boolean;
    onDestroy$ = new Subject();

    constructor(
        public dialogRef: MatDialogRef<AvmPopUpComponent>,
        public lgvClientService: LgvClientService,
        public SSHlpr: LgvSnapshotHelper,
        public Notifications: NotificationService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog) {
    }

    ngOnInit() {
        this.lgvClientService.SelectedProperty$.pipe(takeUntil(this.onDestroy$)).subscribe((sp) => {
            this.marketValueHistory = {
                processedDate: sp.propertyInfo.avmprocessedDate,
                estimatedValue: sp.propertyInfo.avmestimatedValue,
                lowValue: sp.propertyInfo.avmlowValue,
                highValue: sp.propertyInfo.avmhighValue,
                source: sp?.propertyInfo.avmProvider?.name,
                propertyAdjustments: sp?.clientPropertyAdjustments[0]
            };
            this.isManuallyAdjusted = sp?.clientPropertyAdjustments?.length > 0;
        });
    }

    ngOnDestroy() {
        this.onDestroy$.next(false);
        this.onDestroy$.complete();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onAdjustHomeValue() {
        this.dialogRef.close();
        this.dialog.open(AdjustHomeValueDialogComponent, {
            width: '500px',
            minHeight: '700px'
        });
    }

}
